<div class="page-title-area">
    <div class="container">
      <div class="page-title-content">
        <h2>Content Management</h2>
        <ul>
          <li><a routerLink="/services">Services</a></li>
          <li>Content Management</li>
        </ul>
      </div>
    </div>
  </div>